import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IModalContainerState {
  open: boolean;
  content: JSX.Element
  closeButton?: boolean
}

const initialState: IModalContainerState = {
  open: false,
  content: <></>,
  closeButton: false
};

const modalContainerSlice = createSlice({
  name: 'modalContainer',
  initialState,
  reducers: {
    setModalContainerOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setModalContainerContent: (state, action: PayloadAction<JSX.Element>) => {
      state.content = action.payload;
    },
    setModalCloseButton: (state, action: PayloadAction<boolean>) => {
      state.closeButton = action.payload;
    }
  },
});

export const {
  setModalContainerContent,
  setModalContainerOpen,
  setModalCloseButton
} = modalContainerSlice.actions;


export const modalContainerReducer = modalContainerSlice.reducer;